<template>
  <div class="menu-wrapper">
    <!--无子节点-->
    <el-menu-item v-if="menu.children && menu.children.length === 1 && !menu.children[0].path" :index="resolvePath('/', menu.path)" :key="menu.path">
      <svg-icon v-if="menu.meta.iconClass" :icon-class="menu.meta.iconClass" class="icon"></svg-icon>
      {{menu.meta.title}}
    </el-menu-item>
    <!--有一个子节点-->
    <el-submenu v-else-if="menu.children.length === 1 && menu.children[0].path" :index="menu.path" :key="menu.path" :hide-timeout="100">
      <template slot="title">
        <svg-icon :icon-class="menu.meta.iconClass" class="icon"></svg-icon>
        {{menu.meta.title}}
      </template>
      <el-menu-item v-for="submenu in menu.children" :key="submenu.name"
                    :index="resolvePath(menu.path,submenu.path)">
        {{submenu.meta.title}}
      </el-menu-item>
    </el-submenu>
    <!--有多个子节点-->
    <el-submenu v-else-if="menu.children && menu.children.length >= 1" :index="menu.path" :key="menu.path" :hide-timeout="100">
      <template slot="title">
        <svg-icon v-if="menu.meta.iconClass" :icon-class="menu.meta.iconClass" class="icon"></svg-icon>
        {{menu.meta.title}}
      </template>
      <el-menu-item v-for="submenu in menu.children" :key="submenu.name"
                    :index="resolvePath(menu.path,submenu.path)">
        {{submenu.meta.title}}
      </el-menu-item>
    </el-submenu>

  </div>
</template>

<script>
  import path from 'path'
  export default {
    name: 'SidebarItem',
    props: {
      // route配置json
      menu: {
        type: Object,
        required: true
      },
      isNest: {
        type: Boolean,
        default: false
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        onlyOneChild: null
      }
    },
    methods: {
      resolvePath (basePath, routePath) {
        if (this.isExternal(routePath)) {
          return routePath;
        }
        return path.resolve(basePath, routePath);
      },
      isExternal (path) {
        return /^(https?:|mailto:|tel:)/.test(path);
      },
    }
  }
</script>

<style scoped>
  .svg-icon{
    vertical-align: middle!important;margin-right: 4px;
  }
</style>



// WEBPACK FOOTER //
// SidebarItem.vue?8785484a